bam-blog-teaser-item {
  height: 100%;
  display: flex;
  flex-direction: column;

  bal-card {
    height: 100%;
  }

  .bal-card-content {
    height: 100%;
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;

    & bal-button > * span {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .bam-blog-teaser__item-box-content-wrapper {
    flex: 1 1 auto
  }

  bal-heading {
    .title {
      font-size: 1rem !important;
      line-height: 1.5rem !important;
    }
  }

  bal-tag {
    margin-bottom: 1.25rem !important;
    max-width: fit-content;

    .bal-tag__label--is-small {
      font-size: 0.75rem !important;
      line-height: 1.5rem !important;
    }

    @include tablet() {
      margin-bottom: 1rem;
    }
  }

  bal-text {
    &.is-date {
      font-size: 0.75rem !important;
      line-height: 1.25rem !important;
      margin-bottom: 0.25rem !important;
    }
  }

  bal-button {
    .button {
      padding: 4px 10px;
      min-height: 24px;

      @include tablet () {
        padding: 8px 16px;
        min-height: 48px;
      }
    }
  }

  bal-button:not(.is-lead) {
    width: 100%;

    .button {
      width: 100%;
    }
  }

  &.with-image {
    bal-card {
      position: relative !important;
      margin: -45px 16px 0;
    }

    .bam-blog-teaser-item__image-wrapper {
      aspect-ratio: 3/2;
    }
  }

// ----- Style for Big Teaser Context ----- //
  &.is-big {
    display: flex;
    flex-direction: column;
    border-radius: 0;
    padding: 1rem;
    margin-left: -1rem;
    margin-right: -1rem;

    &.purple {
      background-color: var(--bal-color-purple);
    }

    &.green {
      background-color: var(--bal-color-green);
    }

    &.yellow {
      background-color: var(--bal-color-yellow);
    }

    &.red {
      background-color: var(--bal-color-red);
    }

    bal-card {
      position: fixed;
      margin: 0 !important;
      padding: 0 !important;
      background-color: transparent !important;
    }

    bal-heading {
      .title {
        font-size: 1.25rem !important;
        line-height: 1.5rem !important;

        @include tablet () {
          font-size: 1.5rem !important;
          line-height: 2rem !important;
        }

        @include desktop () {
          font-size: 2rem !important;
          line-height: 2.5rem !important;
        }
      }
    }

    bal-tag {
      .bal-tag__label--is-small {
        font-size: 0.875rem !important;
        line-height: 1.5rem !important;

        @include tablet() {
          font-size: 0.875rem !important;
          line-height: 1.5rem !important;
        }

        @include desktop() {
          font-size: 1rem !important;
          line-height: 1.5rem !important;
        }
      }
    }

    bal-text {
      &.is-date {
        @include desktop() {
          font-size: 1rem !important;
          line-height: 1.5rem !important;
        }
      }
    }

    bal-card-content {
      padding-top: 1rem !important;
      padding-left: 0 !important;
      margin: 0 !important;

      @include mobile() {
        padding-right: 0 !important;
        padding-bottom: 2rem !important;
      }
    }

    .bam-blog-teaser-item__image-wrapper {
      flex: 1 1 auto;
    }

    .bam-blog-teaser__item-box {
      align-self: flex-start;
    }

    @include mobile() {
      bal-button.is-lead {
        width: 100%;

        .button {
          width: 100%;
        }
      }
    }

    @include tablet() {
      display: flex;
      flex-direction: row;
      border-radius: 12px;
      padding: 2rem;
      margin-left: 0;
      margin-right: 0;

      bal-card {
        margin: 0 16px;
      }

      bal-card-content {
        padding-top: 0 !important;
      }

      .bam-blog-teaser-item__image-wrapper {
        padding-right: 3.5rem;
        flex: 0 0 50%;
      }

      .bam-blog-teaser__item-box {
        align-self: center;
      }
    }

    @include desktop() {
      padding: 4rem;

      .bam-blog-teaser-item__image-wrapper {
        padding-right: 4rem;
      }

      bal-card-content {
        padding-left: 0 !important;
      }
    }
  }
}
